import {AuthExceptionType} from '../enums/core/auth-exception-type';

export class AuthException {

  private readonly _type: AuthExceptionType;
  private readonly _message: string;
  private readonly _code: number;

  constructor(
    _type: AuthExceptionType,
    _message: string = null,
    _code: number = null
  ) {
    this._type = _type;
    this._message = _message;
    this._code = _code;
  }

  get type(): AuthExceptionType {
    return this._type;
  }

  get message(): string {
    return this._message;
  }

  get code(): number {
    return this._code;
  }

}
